module.exports = __webpack_public_path__ + "static/logo-4b9a93b268aace2db561cac11bdbc858.jpg";